<template>
  <section class="boat-info-steps-sec">
    <div class="sec-round-colors">
      <span class="bg-orange round-small"></span>
      <span class="bg-orange round-small"></span>
      <span class="bg-dark-blue round-big"></span>
      <span class="bg-dark-blue round-small"></span>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="info-steps-card">
            <div class="hex-hover">
              <div class="hex d-flex align-items-center justify-content-center">
                <div class="hexTop"></div>
                <div class="hexBottom"></div>
                <div class="hex-icon"><i class="bx bx-map"></i></div>
              </div>
            </div>
            <div class="steps-content">
              <span class="step-badge">Step 1</span>
              <h4>Browse thousands of boats, all around world</h4>
              <p>
                Determine the date & location for your Yacht rental. Consider
                factors such as your travel itinerary,
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="info-steps-card">
            <div class="hex-hover">
              <div class="hex d-flex align-items-center justify-content-center">
                <div class="hexTop"></div>
                <div class="hexBottom"></div>
                <div class="hex-icon"><i class="bx bx-chat"></i></div>
              </div>
            </div>
            <div class="steps-content">
              <span class="step-badge">Step 2</span>
              <h4>Chat with boat owners to customize the perfect trip</h4>
              <p>
                Check the availability of your desired type for your chosen
                dates and location. Ensure that the rental rates.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="info-steps-card">
            <div class="hex-hover">
              <div class="hex d-flex align-items-center justify-content-center">
                <div class="hexTop"></div>
                <div class="hexBottom"></div>
                <div class="hex-icon"><i class="bx bx-water"></i></div>
              </div>
            </div>
            <div class="steps-content">
              <span class="step-badge">Step 3</span>
              <h4>Meet your captain and get out the water!</h4>
              <p>
                Check the availability of your desired type for your chosen
                dates <br />
                and location.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
